import React from 'react';

const DEFAULT_PIC = require('../../../assets/images/default-sitter.png');

interface IProps {
    profileImage: string;
    size?: 'default' | 'xl' | 'lg' | 'sm' | 'xs';
    mr?: boolean;
}

function UserProfilePicture({ profileImage, size = 'default', mr = true }: IProps) {
    function getSize() {
        switch (size) {
            case 'xl':
                return 160;
            case 'lg':
                return 80;
            case 'sm':
                return 40;
            case 'xs':
                return 20;
            default:
                return 60;
        }
    }
    return (
        <>
            {!profileImage || profileImage === '' ? (
                <img
                    alt="Default Profile"
                    src={DEFAULT_PIC}
                    style={{
                        width: getSize(),
                        height: getSize(),
                        marginRight: mr ? 10 : 0,
                        ...styles.image,
                        objectFit: 'cover',
                    }}
                />
            ) : (
                <img
                    alt="User Profile"
                    src={profileImage}
                    style={{
                        width: getSize(),
                        height: getSize(),
                        marginRight: mr ? 10 : 0,
                        ...styles.image,
                        objectFit: 'cover',
                    }}
                />
            )}
        </>
    );
}

export default UserProfilePicture;

const styles = {
    image: {
        borderRadius: 100,
    },
};
